import AuthStore from './AuthStore';
import DocumentsStore from './DocumentsStore';
import UserStore from './UserStore';
import WelcomeStore from './WelcomeStore';
import MessageStore from './MessageStore';

export type RootStoreOpts = {
  authStorePersistanceKey?: string;
};

export default class RootStore {
  public authStore: AuthStore;

  public userStore: UserStore;

  public welcomeStore: WelcomeStore;

  public documentsStore: DocumentsStore;

  public messageStore: MessageStore;

  constructor(opts: RootStoreOpts) {
    this.authStore = new AuthStore(opts.authStorePersistanceKey);
    this.userStore = new UserStore();
    this.welcomeStore = new WelcomeStore();
    this.documentsStore = new DocumentsStore();
    this.messageStore = new MessageStore();
  }
}
